import {
    CKEDITOR_CLEAR_INSERTION_TEXT
    , CKEDITOR_INSERT_TEXT
} from '../constants/constants'

export const insertText = payload => ({ type: CKEDITOR_INSERT_TEXT, payload });

export const clearInsertionText = () => ({ type: CKEDITOR_CLEAR_INSERTION_TEXT });